export function useProductReviewVoteTracker() {
  const voteTracker = useCookie<string[]>('voteTracker', {
    default: () => [],
    watch: 'shallow',
  })

  const add = (reviewId: string) => voteTracker.value?.push(reviewId)
  const remove = (reviewId: string) => {
    const index = voteTracker.value?.indexOf(reviewId)
    if (index > -1)
      voteTracker.value?.splice(index, 1)
  }

  const save = () => {
    if (voteTracker.value && voteTracker.value != null)
      voteTracker.value = [...voteTracker.value]
  }

  const hasVoted = (reviewId: string) => {
    return voteTracker.value?.includes(reviewId)
  }

  const markAsVoted = (reviewId: string) => {
    add(reviewId)
    save()
  }

  const removeVote = (reviewId: string) => {
    remove(reviewId)
    save()
  }

  return {
    hasVoted,
    markAsVoted,
    removeVote,
  }
}
